import React from 'react';
import { TextStatus } from '@cko/primitives';
import { InfoTooltip } from '../../Tooltip';
const StatusWithTooltip = ({ status, tooltip }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(TextStatus, { interactive: false, mr: "var(--layout-soybean)" }, status),
        tooltip && React.createElement(InfoTooltip, { text: tooltip })));
};
export default StatusWithTooltip;
